import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { trackOrder } from "../components/features/orders/orderApi";
import {
  Grid,
  IconContainerProps,
  Rating,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
  styled,
} from "@mui/material";
import { Card } from "../components/ui/Card";
import Title from "../components/ui/Title";
import { LocalShippingIcon } from "../common/iconsData";
import { Business, Home, Route } from "@mui/icons-material";

import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import { StyledSeperator } from "../components/ui/Seperator";

interface TrackDataType {
  curr_add: string;
  destination: string;
  source: string;
  status_code: string;
  status: string;
  curr_timestamp: string;
  instructions: string;
  measured_weight: string;
  expected_delivery: string;
  service: string;
  return_awb: string;
  event: [
    {
      TimeStamp: string;
      EventCode: string;
      EventDescription: string;
      Location: string;
      DetailStatus: string;
    }
  ];
}

const TrackShipment = () => {
  const { order_id } = useParams();

  const [trackData, setTrackData] = useState<TrackDataType>();

  useEffect(() => {
    if (order_id) {
      trackOrder(order_id)
        .then((data) => setTrackData(data?.data?.data))
        .catch((error) => console.log(error));
    }
  }, []);

  const status = trackData?.status_code === "DL" ? "Delivered" : "";

  //   return (
  //     <>
  //       <Grid container spacing={4}>
  //         <Grid item sm={12} md={8}>
  //           <Card>
  //             <Stack
  //               direction={"row"}
  //               justifyContent={"space-between"}
  //               alignItems={"center"}
  //             >
  //               <Title title={`Order Id: ${order_id ?? ""}`} />
  //               <Title title={trackData?.service ?? ""} />
  //             </Stack>
  //             <StyledSeperator />
  //             <Stack
  //               direction={"row"}
  //               justifyContent={"space-around"}
  //               alignItems={"center"}
  //               marginTop={"40px"}
  //               flexWrap={"wrap"}
  //             >
  //               <Stack justifyContent={"center"} alignItems={"center"}>
  //                 <Business
  //                   sx={{
  //                     fontSize: "40px",
  //                   }}
  //                 />
  //                 <Typography fontSize={"10px"}>Source</Typography>
  //                 <Typography fontSize={"12px"} fontWeight={"600"}>
  //                   {trackData?.source}
  //                 </Typography>
  //               </Stack>
  //               <Stack justifyContent={"center"} alignItems={"center"}>
  //                 <LocalShippingIcon
  //                   sx={{
  //                     fontSize: "30px",
  //                   }}
  //                 />
  //                 <Typography fontSize={"12px"} fontWeight={"500"}>
  //                   {trackData?.service}
  //                 </Typography>
  //               </Stack>

  //               <Stack justifyContent={"center"} alignItems={"center"}>
  //                 <Home
  //                   sx={{
  //                     fontSize: "40px",
  //                   }}
  //                 />
  //                 <Typography fontSize={"10px"}>Destination</Typography>
  //                 <Typography fontSize={"12px"} fontWeight={"600"}>
  //                   {trackData?.destination}
  //                 </Typography>
  //               </Stack>
  //             </Stack>
  //             <StyledSeperator />

  //             {status === "Delivered" && (
  //               <>
  //                 <Stack
  //                   direction={"row"}
  //                   justifyContent={"space-between"}
  //                   alignItems={"center"}
  //                   flexWrap={"wrap"}
  //                 >
  //                   <div>
  //                     <Typography marginTop={"40px"} fontSize={"12px"}>
  //                       Your Order is{" "}
  //                     </Typography>
  //                     <Typography fontSize={"28px"} fontWeight={"600"}>
  //                       {status}
  //                     </Typography>
  //                     <Typography marginBottom={"40px"} fontSize={"14px"}>
  //                       as on {trackData?.curr_timestamp}
  //                     </Typography>
  //                   </div>
  //                   <div>
  //                     <Typography fontSize={"10px"} marginBottom={"10px"}>
  //                       How was your delivery experience?
  //                     </Typography>
  //                     <StyledRating
  //                       name="highlight-selected-only"
  //                       defaultValue={1}
  //                       IconContainerComponent={IconContainer}
  //                       getLabelText={(value: number) => customIcons[value].label}
  //                       highlightSelectedOnly
  //                     />
  //                   </div>
  //                 </Stack>
  //                 <StyledSeperator />
  //               </>
  //             )}
  //             <Typography marginBottom={"20px"}>Tracking history</Typography>
  //             <Card
  //               style={{
  //                 height: "500px",
  //                 overflowY: "scroll",
  //               }}
  //             >
  //               <Stack rowGap={"20px"}>
  //                 <Stepper orientation="vertical">
  //                   {trackData?.event.map((el, index) => {
  //                     return (
  //                       <Step key={index}>
  //                         <StepLabel>
  //                           <Grid container spacing={2} justifyContent="center" alignItems="center">
  //                             <Grid item xs={3} container justifyContent="center">
  //                               <Typography variant="body1" fontWeight="bold" align="center">
  //                                 {el.Location}
  //                               </Typography>
  //                             </Grid>
  //                             <Grid item xs={3} container justifyContent="center">
  //                               <Typography variant="body1" align="center">
  //                                 {el.TimeStamp}
  //                               </Typography>
  //                             </Grid>
  //                             <Grid item xs={3} container justifyContent="center">
  //                               <Typography variant="body1" color="warning.main" align="center">
  //                                 {el.EventDescription}
  //                               </Typography>
  //                             </Grid>
  //                             <Grid item xs={3} container justifyContent="center">
  //                               <Typography variant="body1" color="error.main" align="center">
  //                                 {el.DetailStatus}
  //                               </Typography>
  //                             </Grid>
  //                           </Grid>
  //                         </StepLabel>
  //                       </Step>
  //                     );
  //                   })}
  //                 </Stepper>
  //               </Stack>
  //             </Card>
  //           </Card>
  //         </Grid>
  //       </Grid>
  //     </>
  //   );
  // };






  return (
    <>
      <Grid container spacing={4}>
        <Grid item sm={12} md={8}>
          <Card>
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
              <Title title={`Order Id: ${order_id ?? ""}`} />
              <Title title={trackData?.service ?? ""} />
            </Stack>
            <StyledSeperator />
            <Stack
              direction={"row"}
              justifyContent={"space-around"}
              alignItems={"center"}
              marginTop={"40px"}
              flexWrap={"wrap"}
            >
              <Stack justifyContent={"center"} alignItems={"center"}>
                <Business sx={{ fontSize: "40px" }} />
                <Typography fontSize={"10px"}>Source</Typography>
                <Typography fontSize={"12px"} fontWeight={"600"}>
                  {trackData?.source}
                </Typography>
              </Stack>
              <Stack justifyContent={"center"} alignItems={"center"}>
                <LocalShippingIcon sx={{ fontSize: "30px" }} />
                <Typography fontSize={"12px"} fontWeight={"500"}>
                  {trackData?.service}
                </Typography>
              </Stack>
              <Stack justifyContent={"center"} alignItems={"center"}>
                <Home sx={{ fontSize: "40px" }} />
                <Typography fontSize={"10px"}>Destination</Typography>
                <Typography fontSize={"12px"} fontWeight={"600"}>
                  {trackData?.destination}
                </Typography>
              </Stack>
            </Stack>
            <StyledSeperator />

            {status === "Delivered" && (
              <>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                >
                  <div>
                    <Typography marginTop={"40px"} fontSize={"12px"}>
                      Your Order is{" "}
                    </Typography>
                    <Typography fontSize={"28px"} fontWeight={"600"}>
                      {status}
                    </Typography>
                    <Typography marginBottom={"40px"} fontSize={"14px"}>
                      as on {trackData?.curr_timestamp}
                    </Typography>
                  </div>
                  <div>
                    <Typography fontSize={"10px"} marginBottom={"10px"}>
                      How was your delivery experience?
                    </Typography>
                    <StyledRating
                      name="highlight-selected-only"
                      defaultValue={1}
                      IconContainerComponent={IconContainer}
                      getLabelText={(value) => customIcons[value].label}
                      highlightSelectedOnly
                    />
                  </div>
                </Stack>
                <StyledSeperator />
              </>
            )}

            {/* Additional Information Section */}
            <Stack spacing={2} marginTop={"20px"} padding={"20px"}>
              <Typography variant="h6" align="left">Additional Information</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body1"><strong>Current Address:</strong> {trackData?.curr_add}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1"><strong>Status Code:</strong> {trackData?.status_code}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1"><strong>Instructions:</strong> {trackData?.instructions}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1"><strong>Measured Weight:</strong> {trackData?.measured_weight} kg</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1"><strong>Expected Delivery:</strong> {trackData?.expected_delivery}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1"><strong>Return AWB:</strong> {trackData?.return_awb ?? "N/A"}</Typography>
                </Grid>
              </Grid>
            </Stack>

            {/* Tracking History Section */}
            <Stack marginTop={"40px"}>
              <Typography variant="h6" align="left">Tracking History</Typography>
              <Card style={{ height: "500px", overflowY: "scroll", padding: "20px", backgroundColor: "#f9f9f9", border: "1px solid #ddd", borderRadius: "8px" }}>
                <Stack rowGap={"20px"}>
                  <Stepper orientation="vertical">
                    {trackData?.event.map((el, index) => {
                      return (
                        <Step key={index}>
                          <StepLabel>
                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                              <Grid item xs={3} container justifyContent="center">
                                <Typography variant="body1" fontWeight="bold" align="center">
                                  {el.Location}
                                </Typography>
                              </Grid>
                              <Grid item xs={3} container justifyContent="center">
                                <Typography variant="body1" align="center">
                                  {el.TimeStamp}
                                </Typography>
                              </Grid>
                              <Grid item xs={3} container justifyContent="center">
                                <Typography variant="body1" color="warning.main" align="center">
                                  {el.EventDescription}
                                </Typography>
                              </Grid>
                              <Grid item xs={3} container justifyContent="center">
                                <Typography variant="body1" color="error.main" align="center">
                                  {el.DetailStatus}
                                </Typography>
                              </Grid>
                            </Grid>
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Stack>
              </Card>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </>
  );

};

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled,
  },
}));

const customIcons: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: (
      <SentimentVeryDissatisfiedIcon
        sx={{
          fontSize: "40px",
        }}
        color="error"
      />
    ),
    label: "Very Dissatisfied",
  },
  2: {
    icon: (
      <SentimentDissatisfiedIcon
        sx={{
          fontSize: "40px",
        }}
        color="error"
      />
    ),
    label: "Dissatisfied",
  },
  3: {
    icon: (
      <SentimentSatisfiedIcon
        sx={{
          fontSize: "40px",
        }}
        color="warning"
      />
    ),
    label: "Neutral",
  },
  4: {
    icon: (
      <SentimentSatisfiedAltIcon
        sx={{
          fontSize: "40px",
        }}
        color="success"
      />
    ),
    label: "Satisfied",
  },
  5: {
    icon: (
      <SentimentVerySatisfiedIcon
        sx={{
          fontSize: "40px",
        }}
        color="success"
      />
    ),
    label: "Very Satisfied",
  },
};

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

export default TrackShipment;
